import React from "react";
import { NotificationDto, ProfileId } from "../../types/types";
import NotificationEmptyState from "./notificationEmptyState";
import NotificationItem from "./notificationItem";

interface NotificationListProps {
  notifications: NotificationDto[];
  pendingIds: ReadonlySet<number>;
  onToggleRead: (notificationId: number) => void;
  onProfileClick?: (profileId: ProfileId) => void;
}

const NotificationList: React.FC<NotificationListProps> = ({
  notifications,
  pendingIds,
  onToggleRead,
  onProfileClick,
}) => {
  if (notifications.length === 0) {
    return (
      <div className="flex flex-1 items-center justify-center pb-16">
        <NotificationEmptyState />
      </div>
    );
  }

  return (
    <div className="divide-y divide-slate-100 overflow-hidden rounded-2xl border border-gray-200 bg-white">
      {notifications.map((notification) => (
        <NotificationItem
          key={notification.id}
          notification={notification}
          isUpdating={pendingIds.has(notification.id)}
          onToggleRead={() => onToggleRead(notification.id)}
          onProfileClick={onProfileClick}
        />
      ))}
    </div>
  );
};

export default NotificationList;
